import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { queryKeys, QUERY_CONFIG } from '../../lib/react-query'
import { componentsApi } from '../../services/api/components.api'
import { buildAccessView } from '../../lib/componentAccess'
import { useAuthStore } from '../../store/authStore'

/**
 * Which workflow components the current user may use (plan + role).
 *
 * Re-fetched when the organization changes; callers refetch after a role change.
 * A failed call (503) leaves `known` false — access is unknown, never allowed.
 */
export function useComponentAccess() {
  const orgId = useAuthStore((state) => state.orgId)
  const query = useQuery({
    queryKey: queryKeys.permissions.componentAccess(orgId),
    queryFn: () => componentsApi.getAccess(orgId),
    // A revoke can take up to a minute to reach the workflow service, so a longer cache only hides it.
    staleTime: Math.min(QUERY_CONFIG.DEFAULT_STALE_TIME, 60_000),
    retry: 1,
    enabled: !!orgId,
  })
  const view = useMemo(() => buildAccessView(query.data), [query.data])
  return { ...view, query, isError: query.isError, isPending: query.isPending, refetch: query.refetch }
}
